import { render, staticRenderFns } from "./ProfessionalsCard.vue?vue&type=template&id=3a4b10b8&scoped=true&"
import script from "./ProfessionalsCard.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b10b8",
  null
  
)

export default component.exports